/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React from 'react';
import { MenuIdAppSwitcher } from '@jira/navigation-apps__constants/src/MenuIdAppSwitcher.tsx';
import { TopLevelErrorBoundary } from '@jira/navigation-apps__topnav-common/src/ui/error-boundary/index.tsx';
import type { UnitProfile } from '@atlassian/switcher/unit-tile-app-switcher-icon';
import { AppSwitcherTrigger } from './trigger/index.tsx';

type Props = {
	// NAVX-5411: spike measuring the cost of fetching + rendering a unit tile
	// as the app switcher trigger icon. Sourced from the shared TopNavigation
	// query, null when the experiment is off or unavailable.
	unitProfile: UnitProfile | null;
};

function AppSwitcher({ unitProfile }: Props): React.JSX.Element {
	return (
		<TopLevelErrorBoundary id={MenuIdAppSwitcher}>
			<AppSwitcherTrigger unitProfile={unitProfile} />
		</TopLevelErrorBoundary>
	);
}

export default AppSwitcher;
